import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, shadows } from '../../styles/theme';

export const Card = styled.div`
  background: ${colors.gradients.teal};
  color: ${colors.neutral.white};
  padding: ${spacing['2xl']} ${spacing.xl};
  border-radius: ${borderRadius['2xl']};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.md};
  box-shadow: ${shadows.lg};
`;

export const Title = styled.h3`
  font-size: ${typography.fontSize['2xl']};
  font-weight: ${typography.fontWeight.bold};
  margin: 0;
`;

export const Text = styled.p`
  font-size: ${typography.fontSize.lg};
  opacity: 0.9;
  margin: 0;
  max-width: 600px;
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs};
  padding: 0.875rem 2rem;
  background: ${colors.primary.orange};
  color: ${colors.neutral.white};
  font-weight: ${typography.fontWeight.bold};
  font-size: ${typography.fontSize.base};
  border-radius: ${borderRadius.xl};
  text-decoration: none;
  transition: all 0.25s ease;
  box-shadow: ${shadows.md};

  &:hover {
    background: ${colors.primary.orangeLight};
    transform: translateY(-2px);
    box-shadow: ${shadows.orangeHover};
  }
`;
